import {Component, Input} from '@angular/core';
import {CollectionModel} from "../../shared/models/collection.model";

@Component({
  selector: 'app-product-page-charts',
  templateUrl: './product-page-charts.component.html',
  styleUrls: ['./product-page-charts.component.scss']
})
export class ProductPageChartsComponent {
  @Input() collection: CollectionModel;
  @Input() variableKeys: string[] = [];
}
